import { render, staticRenderFns } from "./Pharmacological.vue?vue&type=template&id=1bbfa5ee&scoped=true"
import script from "./Pharmacological.vue?vue&type=script&lang=js"
export * from "./Pharmacological.vue?vue&type=script&lang=js"
import style0 from "./Pharmacological.vue?vue&type=style&index=0&id=1bbfa5ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfa5ee",
  null
  
)

export default component.exports